// @flow

import * as React from "react"
import styled from "styled-components"

const Container = styled.div`
  margin-left: auto;
  margin-right: auto;
  width: 100%;
  height: 80%;
  align-items: center;
  justify-content: center;
  display: flex;
`

const Info = styled.div`
  text-align: center;
`

class UnsupportedBrowser extends React.Component<{}> {
  render(): React$Element<any> {
    return (
      <Container>
        <Info>
          <h1>Your web browser is not supported.</h1>
          <h2>
            Please download{" "}
            <a href="https://www.google.com/chrome/">Google Chrome</a> or{" "}
            <a href="https://www.mozilla.org/en-US/firefox/new/">
              Mozilla Firefox
            </a>
            .
          </h2>
        </Info>
      </Container>
    )
  }
}

export default UnsupportedBrowser
